import { HttpClient} from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { MonoTypeOperatorFunction, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthAmplifyService } from "src/app/shared/service/auth-amplify.service";
import { TranslationService } from 'src/app/shared/service/translation.service';

@Injectable({
  providedIn: 'root'
})
export class DataServiceService {
  pipe(_arg0: MonoTypeOperatorFunction<unknown>) {
    throw new Error("Method not implemented.");
  }
  API_BASE_URL: string;
  api_header: any;
  qrCode_api_header: any;
  infoUrl:string='';
  api_header_qr:any
  proxyEndpoint:string = environment.proxyUrl
  private readonly getTrackGuidSignal = signal<string>('');
  constructor(private readonly http: HttpClient,
    private readonly authAmplifyService:AuthAmplifyService,
    private readonly _translationService: TranslationService
    ) {
    this.API_BASE_URL = environment.baseURL;
  }

    
    getEvents(pageNo: any, itemsPerPage: any, draft: any, page: any, sortBy: any, order: any, searchText:string) {     
      const enableProfileFeature = this._translationService.featureFlags?.profile.enableProfileFeature?'profile':'admin';
      const url = this.proxyEndpoint + `/getProf/api/v2/${enableProfileFeature}/events?offset=${pageNo}&pageSize=${itemsPerPage}&filter=${draft}&page=${page}&sortBy=${sortBy}&order=${order}&text=${searchText}`;    
      
      return this.http.get(url,{observe: 'response', withCredentials: true});
    }

  uploadLogo(file:File) {
    const formData = new FormData();
    formData.append('file', file);
    // no chane
    const url = this.proxyEndpoint + '/evntmedia/api/v1/admin/media';
    return this.http.post(url, formData, {observe: 'response', withCredentials: true});
  }

  fetchLocationData(val: string) {
    const url = 'https://discover.search.hereapi.com/v1/discover?apiKey=qGl1wvH_lslJj_rJXm5vJkVwZKFBPDXT20DStvsMF0g&at=0,0&q=' + val
    return this.http.get(url, { headers: {} });
  }

  createEvent(obj: any) {
    const url = `${this.proxyEndpoint}/callevnt/api/v2/profile/events`;
      return this.http.post(url, obj, {observe: 'response', withCredentials: true});
  }


  getEventData(id: string) { 
    const url = `${this.proxyEndpoint}/getProf/api/v2/profile/events/${id}`;
    return this.http.get(url,{observe: 'response', withCredentials: true});
  }

  getAllExerciseTypes(){
    const url = this.proxyEndpoint + '/callevnt/api/v2/template/exercise' 
    return this.http.get(url,{observe: 'response', withCredentials: true});
  }

  // v2/profile and profileId in hedaer
  addExercise(eventId: string, exerciseData: any) {
    const url = `${this.proxyEndpoint}/callevnt/api/v2/profile/events/${eventId}/exercises` 
    return this.http.post(url, exerciseData, {observe: 'response', withCredentials: true});
  }
  
  // v2/profile and profileId in hedaer
  updateExercise(eventId:string,exerciseId:string,reqObj:any){
    const url= this.proxyEndpoint + '/callevnt/api/v2/profile/events/'+eventId+'/exercises/'+exerciseId
    return this.http.put(url, reqObj, {observe: 'response', withCredentials: true});

  }
  getLayoutDetails(circuitId:any){
       const url=`${this.proxyEndpoint}/callLocApi/v1/circuit?guid=${circuitId}`
       return this.http.get(url, {observe: 'response', withCredentials: true})
  }

  // unused
  createInfo(value:any){
    const url =this.infoUrl +'/profile/events';
    return this.http.post(url,value)
  }

 // unused
  geteventInfo(id:string){
    const url=this.infoUrl + '/profile/events/' +id
    return this.http.get(url)
  }

  // v2/profile and profileId in hedaer
  deleteExercise(eventId:any,exerciseId:any){
    const url=this.proxyEndpoint+'/callevnt/api/v2/profile/events/'+ eventId+'/exercises/'+exerciseId;
    return this.http.delete(url, {observe: 'response', withCredentials: true})
  }


  // v2/profile and profileId in hedaer
  deleteEvent(id: string) {
    const url = this.proxyEndpoint + '/delProf/api/v2/profile/events/' + id;
    return this.http.delete(url, {observe: 'response', withCredentials: true});
  }

 // v2/profile and profileId in hedaer
  updateEvent(obj: any, id: string) {
    const url = this.proxyEndpoint + '/putProf/api/v2/profile/events/' + id;
    return this.http.put(url, obj, {observe: 'response', withCredentials: true});
  }

  // v2/profile and profileId in hedaer
  getParticipantList(eventId: string, page: any, pageSize: any, searchText?: string) {
    if(searchText?.length) {
      const url = this.proxyEndpoint + `/callevnt/api/v2/profile/events/${eventId}/participants?order=descending&sortBy=createdAt&page=${page}&pageSize=${pageSize}&text=${searchText}`;
      return this.http.get(url,{observe: 'response', withCredentials: true});
    } else {
      const url = this.proxyEndpoint + `/callevnt/api/v2/profile/events/${eventId}/participants?order=descending&sortBy=createdAt&page=${page}&pageSize=${pageSize}`;
      return this.http.get(url,{observe: 'response', withCredentials: true});
    }  
  }


  addPenalty(exerciseId: string, raceId: string, obj: any) {
    return this.http.put(this.proxyEndpoint + '/callevnt/api/v2/profile/exercises/'+exerciseId+'/races/'+raceId, obj, {observe: 'response', withCredentials: true});
  }

  editPenalty(exerciseId: string, raceId: string, obj: any) {
    return this.http.put(this.proxyEndpoint + '/callevnt/api/v2/profile/exercises/'+exerciseId+'/races/'+raceId, obj, {observe: 'response', withCredentials: true});
  }

  deleteRace(exerciseId:string, raceId: string) {
    return this.http.delete(this.proxyEndpoint + '/callevnt/api/v2/profile/exercises/'+exerciseId+'/races/'+raceId, {observe: 'response', withCredentials: true});
  }

  uploadParticipants(eventId: string, file: any) {
    const formData = new FormData();
    formData.append('file', file);
    const url = this.proxyEndpoint + '/uploadpt/api/v2/profile/events/' + eventId + '/batch-participants';
    return this.http.post(url, formData, {observe: 'response', withCredentials: true});
  }

  addParticipant(eventId: string, obj: any) {
    const url = this.proxyEndpoint + '/callevnt/api/v2/profile/events/' + eventId + '/participants';
    return this.http.post(url, obj, {observe: 'response', withCredentials: true});
  }

  editParticipant(eventId: string, obj: any, participantId: string) {
    const url = this.proxyEndpoint + '/callevnt/api/v2/profile/events/' + eventId + '/participants/' + participantId;
    return this.http.put(url, obj, {observe: 'response', withCredentials: true});
  }

  deleteParticipant(eventId: string, participantId: any[]) {
    const url = this.proxyEndpoint + '/callevnt/api/v2/profile/events/' + eventId + '/delete/participants';
    return this.http.post(url,{participants:participantId}, {observe: 'response', withCredentials: true});
  }

  downloadQRcode(eventId: string, type: string, page: any, pageSize: any) {
    // v2/profile/qr-codes
    // send profile id in headrs
    this.api_header_qr = {
      responseType: 'text',
      observe: 'response', withCredentials: true
    };
    
    const url = this.proxyEndpoint + `/getQRF/api/v2/profile/events/${eventId}/qr-codes?type=${type}&page=${page}&pageSize=${pageSize}`;
    return this.http.get(url, this.api_header_qr)
  }

  downloadSelectedQrCodes(eventId:string,participantIds:any,type:string){
    // v2/profile/qr-codes
    // send profile id in headrs
    this.api_header_qr = {
      responseType: 'text',
      observe: 'response', withCredentials: true
    };
    const url = this.proxyEndpoint + `/callevnt/api/v2/profile/events/${eventId}/qr-codes?type=${type}`
    return this.http.post(url,participantIds, this.api_header_qr);
  }

  sendEmail(eventId: string, participantId: string) {
    // v2/profile/events/eventId/participants/participantId/notification
    // send profile id in headrs
    const url = this.proxyEndpoint + '/callevnt/api/v2/profile/events/' + eventId + '/participants/' + participantId +'/notification'
    return this.http.post(url, {observe: 'response', withCredentials: true});
    
  }

  getBestRacesData(eventId: string,exerciseId:string,pageNo:any,pageSize:any,isBestRaces:any) {  //v2 and sendprofileif in headers  
  const url = this.proxyEndpoint + '/callevnt/api/v2/profile/events/' + eventId + '/exercises/' + exerciseId + '/races?pageSize=' +pageSize+ '&isBestRaces='+isBestRaces+'&page=' +pageNo;
    return this.http.get(url, {observe: 'response', withCredentials: true});
  }
    //v2 and sendprofileif in headers  

  getBestRacesSerchData(eventId: string,exerciseId:string,serchedKey:any,pageNo:any,pageSize:any,isBestRaces?:any) {
    const url = this.proxyEndpoint + '/callevnt/api/v2/profile/events/' + eventId + '/exercises/' + exerciseId + '/races?text=' +serchedKey+ '&pageSize=' +pageSize+ '&isBestRaces='+isBestRaces+'&page=' +pageNo;
    return this.http.get(url, {observe: 'response', withCredentials: true});
  }
      //v2 and sendprofileif in headers  

  deleteBestRace(exercise_id:any,race_id:any){
    const url = this.proxyEndpoint + '/callevnt/api/v2/profile/exercises/' +exercise_id + '/races/' + race_id;
    return this.http.delete(url);
  }

  getAliasList(){ // don't send
    const url=this.proxyEndpoint +"/callevnt/api/v2/profile"
    return this.http.get(url, {observe: 'response', withCredentials: true});
  }
  // unused
  getMemberList(groupName:any){
    const url=`${this.proxyEndpoint}/callevnt/api/v2/profile/members?groupname=${groupName}`
    return this.http.get(url, {observe: 'response', withCredentials: true});
  }

  // v2/profile and profileId in hedaer
  addScore(event_id:any,exercise_id:any,participant_id:any,obj:any){
    const url = `${this.proxyEndpoint}/callevnt/api/v2/profile/events/${event_id}/score/${exercise_id}/participants/${participant_id}`;
    return this.http.put(url,obj, {observe: 'response', withCredentials: true});
  }

  getScore(event_id:any,exercise_id:any,page?:any,pageSize?:any,searchText?:any){
    if(searchText?.length>0 ){
      const url = `${this.proxyEndpoint}/callevnt/api/v2/profile/events/${event_id}/score/${exercise_id}/participants?order=descending&sortBy=createdAt&page=${page}&pageSize=${pageSize}&text=${searchText}`;
      return this.http.get(url, {observe: 'response', withCredentials: true});
    }else{
    const url = `${this.proxyEndpoint}/callevnt/api/v2/profile/events/${event_id}/score/${exercise_id}/participants?order=descending&sortBy=createdAt&page=${page}&pageSize=${pageSize}`;
    return this.http.get(url, {observe: 'response', withCredentials: true});
    }
  }

  // v2/profile and profileId in hedaer
  getPaginatedLatestRaces(eventId: string,exerciseId:string, page?: number, pageSize?: number,searchText?:any) {
    if(searchText?.length>0 ){
    const url=`${this.proxyEndpoint}/callevnt/api/v2/profile/events/${eventId}/exercises/${exerciseId}/races?pageSize=${pageSize}&page=${page}&text=${searchText}`
		return this.http.get(url, {observe: 'response', withCredentials: true});
    }else{
      const url=`${this.proxyEndpoint}/callevnt/api/v2/profile/events/${eventId}/exercises/${exerciseId}/races?pageSize=${pageSize}&page=${page}`
      return this.http.get(url, {observe: 'response', withCredentials: true});
    }
	}

  getPaginatedRacesForVideoStatus(eventId: string,exerciseId:string, isBestRaces:any, page?: number, pageSize?: number,searchText?:any) {
    if(searchText?.length>0 ){
    const url=`${this.proxyEndpoint}/callevnt/api/v2/profile/events/${eventId}/exercises/${exerciseId}/races?pageSize=${pageSize}&page=${page}&text=${searchText}&isBestRaces=${isBestRaces}`
		return this.http.get(url, {observe: 'response', withCredentials: true});
    }else{
      const url=`${this.proxyEndpoint}/callevnt/api/v2/profile/events/${eventId}/exercises/${exerciseId}/races?pageSize=${pageSize}&page=${page}&isBestRaces=${isBestRaces}`
      return this.http.get(url, {observe: 'response', withCredentials: true});
    }
	}

  resendEmail(eventId:any,participantId:any){
    const url=`${this.proxyEndpoint}/callevnt/api/v2/profile/events/${eventId}/participants/${participantId}/notification`
		return this.http.get(url, {observe: 'response', withCredentials: true});
  }

  public getParticipantLocales(): Observable<any> {
    const url=`${this.proxyEndpoint}/callevnt/api/v2/profile/locales`
    return this.http.get(url, {observe: 'response', withCredentials: true});
  }

  downloadQrtemplate(eventId:any){
    const url=`${this.proxyEndpoint}/getPdf/api/v2/profile/events/${eventId}/reg-template`
    this.api_header_qr = {
      responseType: 'text',
      observe: 'response', withCredentials: true
    };
		return this.http.get(url,this.api_header_qr);
  }

  uploadPdfFile(file:File) {
    const formData = new FormData();
    formData.append('file', file);
    const url = this.proxyEndpoint + '/evntmedia/api/v1/admin/media?content-disposition=inline';
    return this.http.post(url, formData, {observe: 'response', withCredentials: true});
  }

  updateTrackGuidSignalValue(trackGuid: string): void {
    this.getTrackGuidSignal.set(trackGuid);
  }

  getTrackGuidSignalValue(): WritableSignal<string> {
    return this.getTrackGuidSignal;
  }
  
}


